import { FeatureFlagResource } from '../../api/model/featureFlagResource';

/**
 * Checks if a user has a specific feature flag enabled
 * @param user The user resource to check
 * @param identifier The feature flag identifier (e.g., 'board_feature')
 * @returns true if the user has the feature flag enabled, false otherwise
 */
export function hasFeatureFlag(
    user: { featureFlags?: Array<FeatureFlagResource> | null } | null | undefined,
    identifier: string,
): boolean {
    if (!user || !user.featureFlags || !Array.isArray(user.featureFlags)) {
        return false;
    }

    const featureFlag = user.featureFlags.find(
        flag => flag.identifier === identifier
    );

    return featureFlag?.isEnabled === true;
}
